<template>
  <a-drawer :width="drawerWidth" :visible="visible"
    :body-style="{ paddingBottom: '80px', height: 'calc(100vh - 55px)', overflowY: 'auto' }" @close="onClose">
    <template slot="title">
      <div style="display: flex; align-items: center; gap: 10px;">
        <a-avatar v-if="isImageUrl(icon)" :src="icon" shape="square" size="small" />
        <a-icon v-else-if="icon" :type="icon" style="color: #1a1a2e; font-size: 18px;" />
        <span style="font-weight: 800; font-size: 16px;">{{ title }}</span>
      </div>
    </template>
    <OrganizationChart v-if="visible && title === 'Human Resources Section Organize Chart and Job Responsibilities'" />
    <Onboarding v-if="visible && title === 'On-boarding'" />
    <Financialcompensation v-if="visible && title === 'Financial Compensation'" />
    <TimeAttendance v-if="visible && title === 'สรุปข้อมูลการทำงานสาย'" />
    <DocumentsCertificates v-if="visible && title === 'Documents & Certificates'" />
    <ViewListRequest v-if="visible && title === 'รายการคำขอ'" />
    <PerformanceManagement v-if="visible && title === 'Performance Management'" />
    <PerformanceChair v-if="visible && title === 'Performance Management Guideline for Division Chairs'" />
    <Retirement v-if="visible && title === 'Retirement Information'" />
    <Visaworkpermit v-if="visible && title === 'VISA & Work Permit'" />
    <Welfarebenefits v-if="visible && title === 'Welfare & Benefits'" />
    <LearningDevelopment v-if="visible && title === 'Learning & Development'" :contract-name-eng="contractNameEng" />
    <slot></slot>
    <div :style="{
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    }">
      <a-button type="danger" :style="{ marginRight: '8px' }" @click="onClose">
        Close
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import OrganizationChart from './organization.vue';
import Onboarding from './onboarding.vue';
import Financialcompensation from './financialcompensation.vue';
import TimeAttendance from '../../accesslog/timeattandance.vue';
import DocumentsCertificates from './documentscertificates.vue';
import ViewListRequest from './viewlistrequest.vue';
import PerformanceManagement from './performancemanagement.vue';
import PerformanceChair from './performancechair.vue';
import Retirement from './retirement.vue';
import Visaworkpermit from './visaworkpermit.vue';
import Welfarebenefits from './welfarebenefits.vue';
import LearningDevelopment from './learningdevelopment.vue';

export default {
  components: {
    OrganizationChart,
    Onboarding,
    Financialcompensation,
    TimeAttendance,
    DocumentsCertificates,
    ViewListRequest,
    PerformanceManagement,
    PerformanceChair,
    Retirement,
    Visaworkpermit,
    Welfarebenefits,
    LearningDevelopment
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    contractNameEng: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    drawerWidth() {
      return this.windowWidth < 768 ? '100vw' : '80vw';
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    onClose() {
      this.$emit('close')
    },
    isImageUrl(val) {
      return val && (val.includes('/') || val.includes('.png') || val.includes('.jpg') || val.includes('.svg'));
    }
  }
}
</script>